<template>
  <el-dropdown split-button size="mini" type="info" trigger="click" @command="handleCommand">
    <strong v-if="this.value">{{ selectedIndex }}</strong>
    <strong v-else>?</strong>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="(question, index) in canvasQuestions"
        :key="index"
        :command="question"
        :disabled="excludeQuestions.includes(question.id)"
      >
        <strong>{{ index + 2 }}.</strong>
        {{ question.title }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ConditionalLinkSelect',
  props: {
    value: {
      type: Number,
    },
    excludeQuestions: {
      value: {
        type: Array,
        default: () => [],
      },
    },
  },
  computed: {
    ...mapState('surveybuilder', ['canvasQuestions']),

    selectedIndex() {
      if (!this.value) {
        return '';
      }

      const index = this.canvasQuestions.findIndex(q => q.id === this.value);
      return index >= 0 ? index + 2 : null;
    },

    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value.id);
      },
    },
  },
  methods: {
    handleCommand(question) {
      this.computedValue = question;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConditionalLinkSelect.vue?927962a8